import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

import type { AuditLogsFilters } from '../hooks/useAuditLogsGroups';

interface AuditLogsState {
  filters?: AuditLogsFilters;
  isOpen: boolean;
  title: string;
}

interface AuditLogsContextType {
  closeAuditLogs: () => void;
  openAuditLogs: (filters: AuditLogsFilters, title?: string) => void;
  state: AuditLogsState;
}

const AuditLogsContext = createContext<AuditLogsContextType | undefined>(undefined);

const AuditLogsProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<AuditLogsState>({
    isOpen: false,
    title: 'Audit Logs'
  });

  const openAuditLogs = (filters: AuditLogsFilters, title = 'Audit Logs') => {
    setState({ isOpen: true, filters, title });
  };

  const closeAuditLogs = () => {
    setState((prev) => ({ ...prev, isOpen: false }));
  };

  return <AuditLogsContext.Provider value={{ state, openAuditLogs, closeAuditLogs }}>{children}</AuditLogsContext.Provider>;
};

export default AuditLogsProvider;

export const useAuditLogs = () => {
  const context = useContext(AuditLogsContext);

  if (!context) {
    throw new Error('useAuditLogs must be used within an AuditLogsProvider');
  }
  return context;
};
